import React, { useContext } from 'react'
import { RootContext } from 'src/context/rootContext'
import ModalBackIcon from '../../../static/icons/arrow-left-mobile.svg'
import ModalCloseIcon from '../../../static/icons/close-menu-icon.svg'
import PropTypes from 'prop-types'

import { BodyScrollLock } from '../styled'
import {
  ModalBox,
  ModalBody,
  ModalTitle,
  ModalSubtitle,
  ModalContent,
  ModalBackdrop,
  ModalClose,
  ModalBack,
  ModalHeaderWrapper
} from './styles'

const ModalSheet = ({
  visible,
  title,
  dataTest,
  subtitle,
  decentralizedSubTitle,
  children,
  onCancel,
  icon,
  modalHeight,
  modalWidth,
  showBackButton = true,
  showCloseButton,
  largeHeaderGap
}) => {
  const { toggleModalSheet } = useContext(RootContext)
  return (
    <>
      <ModalBackdrop visible={visible} onClick={() => toggleModalSheet({}, true)} data-test={`${dataTest}-backdrop`} />
      <ModalBox visible={visible} data-test={dataTest} modalHeight={modalHeight} modalWidth={modalWidth}>
        {showBackButton && (
          <ModalBack>
            <ModalBackIcon onClick={() => onCancel()} />
          </ModalBack>
        )}
        {showCloseButton && (
          <ModalClose>
            <ModalCloseIcon onClick={() => onCancel()} />
          </ModalClose>
        )}
        <ModalBody>
          {icon && icon}
          <ModalHeaderWrapper largeHeaderGap={largeHeaderGap}>
            <ModalTitle data-test={`${dataTest}-title`}>{title}</ModalTitle>
            {subtitle && <ModalSubtitle decentralizedSubTitle={!!decentralizedSubTitle} data-test={`${dataTest}-subtitle`}>{subtitle}</ModalSubtitle>}
          </ModalHeaderWrapper>
          {children && <ModalContent data-test={`${dataTest}-content`}>{children}</ModalContent>}
        </ModalBody>
      </ModalBox>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default ModalSheet

ModalSheet.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  iconSize: PropTypes.number,
  subtitle: PropTypes.string,
  decentralizedSubTitle: PropTypes.bool,
  largeHeaderGap: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.object,
  modalHeight: PropTypes.number,
  modalWidth: PropTypes.number,
  showBackButton: PropTypes.bool
}
